var Rooms = React.createClass({
    mixins: [React.addons.PureRenderMixin],
    rendered: 0,
    getInitialState: function() {
        return {
            sort: {
                by: 'oldest',
                type: 'all',
                string: '',
            },
        }
    },
    getDefaultProps: function() {
        return {
            items: [],
        }
    },
    render: function() {
        var sorted = this.props.items
        switch (this.state.sort.by) {
            case 'oldest':
                sorted = this.props.items.slice(0)
                break

            case 'newest':
                sorted = this.props.items.slice(0).reverse()
                break

            case 'type':
                sorted = this.props.items.slice(0).sort(function(a, b) {
                    if (a[2] < b[2]) return -1
                    else return 1
                })
                break

            case 'playerascend':
                sorted = this.props.items.slice(0).sort(function(a, b) {
                    if (a[3].length < b[3].length) return -1
                    else return 1
                })
                break

            case 'playerdescend':
                sorted = this.props.items.slice(0).sort(function(a, b) {
                    if (a[3].length > b[3].length) return -1
                    else return 1
                })
                break
        }
        if (!sorted) {
            sorted = this.props.items || []
        }
        if (this.state.sort.type !== 'all') {
            sorted = sorted.filter(e => e[2] === this.state.sort.type)
        }

        if (this.state.sort.string) {
            sorted = sorted.filter(e => {
                var ret = false
                for (var player in e[3])
                    ret = this.search(this.state.sort.string, e[3][player][0]) == true ? true : ret
                return ret
            })
        }

        var games = [
            ['9ball', '9ball', 0],
            ['balloono', 'Balloono', 0],
            ['balloonobeta', 'Balloono Beta', 0],
            ['balloonoboot', 'Balloono Boot', 0],
            ['blockles', 'Blockles', 0],
            ['blocklesmulti', 'Blockles M', 0],
            ['bubbles', 'Bubbles', 0],
            ['bubblesni', 'Bubbles NI', 0],
            ['checkers', 'Checkers', 0],
            ['cuacka', 'Cuacka', 0],
            ['dinglepop', 'Dinglepop', 0],
            ['gemmers', 'Gemmers', 0],
            ['pool', 'Pool', 0],
            ['skypigs', 'Skypigs', 0],
            ['swapples', 'Swapples', 0],
            ['tonk3', 'Tonk', 0],
            ['watchtogether', 'WatchTogether', 0],
            ['watchtogether', 'WatchTogether', 0],
        ]

        for (var game in games) {
            for (var item in this.props.items) {
                if (games[game][0] === this.props.items[item][2]) {
                    games[game][2]++
                }
            }
        }

        return (
            <div className="rooms ">
				<Box row wrap className="toolbar">
					<Box grow row>
						Rooms ({this.props.items.length ? this.props.items.length : 0})
						{this.state.sort.type !== 'all' || this.state.sort.string !== '' ? (
							<span>Shown ({sorted.length})</span>
						) : null}{' '}
					</Box>

					<div>
						<label className="inline">
							<span className="sort-label">Sort:</span>
							<select ref="sortby" onChange={this.updateSort}>
								<option defaultValue value="oldest">
									Oldest First
								</option>
								<option value="newest">Newest First</option>
								<option value="playerascend">Number of Players (asc)</option>
								<option value="playerdescend">Number of Players (des)</option>
								<option value="type">Game Type</option>
							</select>
						</label>
					</div>
					<div>
						<label className="inline">
							<span className="sort-label">Filter:</span>
							<select ref="sorttype" onChange={this.updateSort}>
								<option defaultValue value="all">
									All
								</option>
								{games.map((game, i) => {
									return (
										<option value={game[0]} key={i}>
											({game[2]}) {game[1]}
										</option>
									)
								})}
							</select>
						</label>
					</div>
					<div>
						<label className="inline">
							<span className="sort-label">Filter:</span>
							<input placeholder="Username" onChange={this.updateFilter} />
						</label>
					</div>
				</Box>
				<Box row wrap grow className="rooms-container-flex">
					{sorted.map(
						function (item, x) {
							return (
								<Box
									key={item[0]}
									data-id={item[0]}
									data-game={item[2]}
									className="room break"
									title="Click to join the room"
									onClick={this.join}
									grow
								>
									<div className="name-container">
										<span className="name">
										<span className="guests" title={'Guests allowed: ' + item[5]}>
										<svg aria-hidden="true"
										data-prefix="fas"
										data-icon="guests"
										role="img"
										fill={
											item[5] ? 'greenyellow' : 'red'
										}
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 300 200"
										style={{ height: 18, width: 18, paddingRight:'5px'}}
										xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1">
										<path d="M.49892.98348q.16746,0,.3349,0A.02547.02547,0,0,0,.86242.955C.8625.92264.86278.89022.86234.85782a.35054.35054,0,0,0-.02-.11456A.3586.3586,0,0,0,.69937.56.35206.35206,0,0,0,.44515.50413.35307.35307,0,0,0,.21554.63805.3417.3417,0,0,0,.13931.83422C.137.87343.13781.91282.13742.95213.13721.97464.14622.98347.16874.98348ZM.5.45117A.21733.21733,0,1,0,.2825.23754.21745.21745,0,0,0,.5.45117Z"/>
										<path d="M.49945.01648A.21542.21542,0,0,0,.34461.08163.21937.21937,0,0,0,.28247.23755.21766.21766,0,0,0,.49994.45117.21308.21308,0,0,0,.65228.38882.21449.21449,0,0,0,.71722.22717a.21962.21962,0,0,0-.06446-.148A.215.215,0,0,0,.49945.01648Z" />
										<path d="M.868.89307.86755.86362.86639.83423A.34713.34713,0,0,0,.85905.78068.33214.33214,0,0,0,.84375.7301.342.342,0,0,0,.82069.68255.37569.37569,0,0,0,.79016.63806.38931.38931,0,0,0,.74253.58778.34428.34428,0,0,0,.62766.52061.375.375,0,0,0,.56055.50409L.53355.50118.507.50024V.49963L.50488.49979.50281.49994.50073.49979.49866.49963V.50024L.47212.50118l-.027.00291A.37453.37453,0,0,0,.378.52061.344.344,0,0,0,.26315.58778.38931.38931,0,0,0,.21552.63806.3745.3745,0,0,0,.185.68255.34087.34087,0,0,0,.16193.7301.33331.33331,0,0,0,.14662.78068.34959.34959,0,0,0,.13928.83423L.13811.86366.13763.89313.13757.92261.13745.95209A.0498.0498,0,0,0,.13908.96648L.14459.9762.15434.98173.16876.98346H.83691L.85133.9817.86108.9762.8666.96648A.0498.0498,0,0,0,.86823.95209L.8681.92258Z" />
										</svg>

										
									</span>

											<span
												dangerouslySetInnerHTML={{
													__html: (this.guests_allowed(item)),
												}}
											/>
											<span
												dangerouslySetInnerHTML={{
													__html: u.linky_no_link_cached(this.room_name(item)),
												}}
											/>
											{/-[0-9]+$/.test(item[0]) ? (
												<img className="ranked" src="img/medals/gold.png" />
											) : null}
											<img
												className="creator"
												title={'Creator ' + item[4].u}
												src={
													is_video(item[4].i)
														? profile_picture(item[4].i).replace(/\.[^\.]+$/, '.png')
														: profile_picture(item[4].i)
												}
											/>
										</span>
									</div>
									{item[3] ? (
										<div className="image-container">
											{item[3].map(function (user) {
												var img = (user && user[1] && user[1].indexOf('http') === 0
													? user[1]
													: (user && user[1])
													? 'https://mobcpop.com/profile/' + user[1]
													: 'https://mobcpop.com/img/user.png'
												).replace('profile/', 'profile/')
												return (
													<span key={item[0] + '-' + user[0]}>
														{!is_video(img) ? (
															<img
																className="profile-image"
																title={user[0]}
																src={img}
																width="30"
																height="30"
															/>
														) : (
															<img
																className="profile-image"
																title={user[0]}
																src={img.replace(/\.[^\.]+$/, '.png').replace('profile/', 'profile/thumb_')}
																width="30"
																height="30"
															/>
														)}
														{user[2] ? <img src={u.badge(user[0])} className="donated" /> : null}
													</span>
												)
											})}
										</div>
									) : null}
								</Box>
							)
						}.bind(this),
					)}
				</Box>
			</div>
        )
    },
    updateSort: function(e) {
        if (e && e.target) {
            var sort = {
                by: this.refs.sortby.value,
                type: this.refs.sorttype.value,
                string: this.state.sort.string,
            }
            this.setState({ sort: sort })
        }
    },
    updateFilter: function(e) {
        var sort = {
            by: this.state.sort.by,
            type: this.state.sort.type,
            string: e.target.value,
        }
        this.setState({ sort: sort })
    },
    room_name: function(item) {
        var user = 'Lame Guest'
        if (item[3].length) user = item[3][0][0]
        return item[1].replace(/#name#/g, user)
    },
    guests_allowed: function(item) {
        // if item[5] 
    },
    join: function(e) {
        if (!$(e.currentTarget).parents('.sidebar-container').length || isMobile) {
            location.hash = 'm/' + $(e.currentTarget).attr('data-id')
        } else {
            window.open('#m/' + $(e.currentTarget).attr('data-id'), '_blank')
        }
    },
    search: function(search, string) {
        string = string.trim().toLowerCase()
        if (search.trim() == '') return true
        //finding "or" conditions
        search = search
            .trim()
            .toLowerCase()
            .replace(/ or /gi, ' ')
            .replace(/,/g, ' ')
            .replace(/ +/g, ' ')
        search = search.split(' ')

        //for each "or" condition - if no "or" conditions was found, this will loop one time.
        for (var id in search) {
            var sub_search = search[id].trim().split(' ')
            var found = false

            //foreach word to search
            for (var id2 in sub_search) {
                var word = sub_search[id2].trim()

                if (word == '' || word == '-' || word == '+') {
                    continue
                } else if (word[0] == '-' && string.indexOf(word.replace(/^-/, '')) != -1) {
                    found = false
                    break
                } else if (word[0] != '-' && string.indexOf(word) == -1) {
                    found = false
                    break
                } else {
                    found = true
                }
            }
            if (found) return true
        }
        return false
    },
})